'use strict';

if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

// fetch() polyfill for making API calls.
require('whatwg-fetch');

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = require('object-assign');

// Support for IE 11 :(
// https://babeljs.io/docs/en/babel-polyfill
require("@babel/polyfill");

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (process.env.NODE_ENV === 'test') {
  require('raf').polyfill(global);
}

// Polyfill for CustomEvent constructor to support IE11.
if ( typeof window.CustomEvent !== 'function' ) {
  require('custom-event-polyfill');
}



//////////////////
// WEBPACK FOOTER
// ./config/polyfills.js
// module id = 466
// module chunks = 0 1 2 3 4 5